import type { QuoteType } from 'src/types/miscType'
import {
	createNewRecapCostLineAicp,
	createRecapInfoAicp,
	createRecapInfoCostLineIdsAndLabelsAicp,
	refreshRecapInfoAicp,
} from 'src/utils/recapGridUtils/createQuoteRecapInfoUtil/createQuoteRecapInfoUtilAicp'
import {
	createNewRecapCostLineFrenchApfp,
	createRecapInfoCostLineIdsAndLabelsFrenchApfp,
	createRecapInfoFrenchApfp,
	refreshRecapInfoFrenchApfp,
} from 'src/utils/recapGridUtils/createQuoteRecapInfoUtil/createQuoteRecapInfoUtilFrenchApfpAndPostProd'

function getCreateQuoteRecapInfoUtil(quoteType?: QuoteType) {
	switch (quoteType) {
		case 'frenchApfp':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'frenchPostProd':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'aicp':
			return {
				createRecapInfo: createRecapInfoAicp,
				refreshRecapInfo: refreshRecapInfoAicp,
				createNewRecapCostLine: createNewRecapCostLineAicp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsAicp,
			}
		case 'photoGrid':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'soundProd':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'cnc5ch':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'quoteAnimationOnly':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'quoteAnimationAndLiveAction':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'blankQuote':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case 'quoteDigital':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		case '360Template':
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		default: {
			// By default return apfp
			console.log('Adding new Recap costline is defaulting to apfp')
			return {
				createRecapInfo: createRecapInfoFrenchApfp,
				refreshRecapInfo: refreshRecapInfoFrenchApfp,
				createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
				createRecapInfoCostLineIdsAndLabels:
					createRecapInfoCostLineIdsAndLabelsFrenchApfp,
			}
		}
	}
}

export { getCreateQuoteRecapInfoUtil }
